import React from 'react';
import { Box, Typography, alpha, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import HomeLayout from '../../asset/layout/HomeLayout';
import UsersOrdersTab from './UsersOrdersTab';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
};

const UsersOrdersPage = () => {
  return (
    <HomeLayout>
      <Box
        sx={{
          minHeight: '100%',
          background: 'linear-gradient(180deg, #f0f4fa 0%, #f5f7fa 35%, #eef2f7 100%)',
          mx: -3,
          mt: -3,
          px: 3,
          pt: 3,
          pb: 4,
        }}
      >
        {/* Hero */}
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              mb: 3,
              borderRadius: '24px',
              background:
                'linear-gradient(135deg, #0c3483 0%, #11409B 40%, #1e40af 70%, #2563eb 100%)',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(17, 64, 155, 0.35)',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: -50,
                right: -30,
                width: 200,
                height: 200,
                borderRadius: '50%',
                bgcolor: alpha('#fff', 0.06),
              }}
            />
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <ShoppingBagOutlinedIcon />
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, letterSpacing: '0.1em', opacity: 0.85 }}
              >
                USER'S ORDERS
              </Typography>
            </Stack>
            <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: '-0.03em' }}>
              User's orders & transactions
            </Typography>
            <Typography sx={{ mt: 1, opacity: 0.82, maxWidth: 520 }}>
              View paginated users with order metrics, real-time status breakdowns (Success,
              Pending, Failed), and detailed orders.
            </Typography>
          </Box>
        </motion.div>

        <UsersOrdersTab />
      </Box>
    </HomeLayout>
  );
};

export default UsersOrdersPage;
